//Global keys
let locales = {
    notificationList_title: 'Notificaciones',
    notificationList_buttonAllNotifications: 'todas',
    notificationList_buttonNotReadNotifications: 'No vistas',
    notificationList_buttonWatchAllNotifications: 'Ver todas las notificaciones',
    notificationList_moreNotifications: 'Hay más notificaciones por ver...'
};
export default locales;